// src/store/services/users.js
import feathersClient, { BaseModel, makeServicePlugin } from '../../feathers-client';
export class RSS2SqlImport extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'rss2sql-import';
    // Define default properties here
    static instanceDefaults() {
        return {
            id: '',
            status: 'started'
        };
    }
}
const servicePath = 'rss2sql-import';
const servicePlugin = makeServicePlugin({
    Model: RSS2SqlImport,
    service: feathersClient.service(servicePath),
    servicePath,
});
// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
});
export default servicePlugin;
